import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const MaskedLine = ({ children, delay, className = "", testId }) => (
  <div className="overflow-hidden py-1">
    <motion.div
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.3, delay, ease: EASE }}
      className={className}
      data-testid={testId}
    >
      {children}
    </motion.div>
  </div>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const textY = useTransform(scrollYProgress, [0, 1], [0, -80]);

  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-end overflow-hidden px-6 md:px-12 pb-16 pt-32"
    >
      <motion.div style={{ y: textY }} className="relative z-10">
        <div className="overflow-hidden mb-8">
          <motion.p
            initial={{ y: "100%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay: 0.2, ease: EASE }}
            className="text-xs uppercase tracking-[0.3em] text-gold"
            data-testid="hero-overline"
          >
            Entretien & travaux — Valréas, Vaucluse
          </motion.p>
        </div>

        <h1 className="font-serif leading-[0.9] tracking-tighter text-[16vw] md:text-[11vw]">
          <MaskedLine delay={0.35} testId="hero-line-1">un habitat</MaskedLine>
          <MaskedLine delay={0.5} className="italic font-light text-gold" testId="hero-line-2">
            bien entretenu,
          </MaskedLine>
          <MaskedLine delay={0.65} testId="hero-line-3">c'est élémentaire.</MaskedLine>
        </h1>

        <div className="overflow-hidden mt-10 max-w-md">
          <motion.p
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: 0.9, ease: EASE }}
            className="text-sm md:text-base text-ash leading-relaxed font-light"
            data-testid="hero-subtitle"
          >
            Nettoyage et désinfection de climatisation, nettoyage de panneaux
            solaires, gouttières, ramonage et petits travaux d'entretien.
            Un artisan de confiance à Valréas et les alentours.
          </motion.p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.6 }}
        className="absolute bottom-8 right-6 md:right-12 flex items-center gap-3"
        data-testid="hero-scroll-hint"
      >
        <span className="text-[10px] uppercase tracking-[0.3em] text-ash">Défiler</span>
        <motion.span
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="block w-px h-10 bg-gold"
        />
      </motion.div>
    </section>
  );
};
